<template>
  <div class="content">
    <el-form :model="formAbonado" ref="formAbonado" :label-position="'top'">
      <div class="d-flex justify-content-between">
        <h5>Datos del vehículo</h5>
        <el-button
          type="primary"
          round
          size="small"
          @click="dialog_add_vehiculo = true"
          >agregar datos de vehículo</el-button
        >
      </div>
      <div class="div my-4">
        <table class="table table-bordered mb-4">
          <colgroup>
            <col class="col-md-1" />
            <col class="col-md-2" />
            <col class="col-md-2" />
            <col class="col-md-2" />
            <col class="col-md-2" />
            <col class="col-md-2" />
          </colgroup>
          <tr class="bg-gray-100 text-center">
            <th scope="col">Tipo</th>
            <th scope="col">Marca</th>
            <th scope="col">Modelo</th>
            <th scope="col">Placa</th>
            <th scope="col">Color</th>
            <th scope="col">N° Motor</th>
          </tr>
          <tbody>
            <tr v-for="(item, index) in listVehiculos" :key="index">
              <td>{{item.idcategory}}</td>
              <td>{{item.marca}}</td>
              <td>{{item.modelo}}</td>
              <td>{{item.placa}}</td>
              <td>{{item.color}}</td>
              <td>{{item.motor}}</td>
            </tr>

          </tbody>
        </table>
      </div>

      <h5>Datos del propietario</h5>

      <!--<div class="row">
        <div class="col-sm-6">
            <el-form-item label="Documento" prop="tdocument">
                <el-select v-model="formAbonado.tdocument" placeholder="Selecciona" size="medium">
                    <el-option v-for="item in documents_identity" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
        </div>
        <div class="col-sm-6">
            <el-form-item label="N° Documento" prop="ndocument">
                <el-input v-model="formAbonado.ndocument" maxlength="11" size="medium"></el-input>
            </el-form-item>
        </div>
    </div>-->

      <el-form-item
        class="mb-4"
        prop="ndocument"
        :rules="[
          {
            required: true,
            message: 'Este campo es obligatorio',
            trigger: 'change',
          },
        ]"
      >
        <el-input
          placeholder="Nro documento"
          v-model="formAbonado.ndocument"
          class="input-with-select"
          size="medium"
          :clearable="true"
          :maxlength="maxlength"
        >
          <el-select
            v-model="formAbonado.tdocument"
            slot="prepend"
            placeholder="Documento"
          >
            <el-option
              v-for="item in documents_identity"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-input>
      </el-form-item>

      <el-form-item
        label="Nombres y apellidos completos"
        prop="firstname"
        :rules="[
          {
            required: true,
            message: 'Este campo es obligatorio',
            trigger: 'change',
          },
        ]"
      >
        <el-input
          v-model="formAbonado.firstname"
          maxlength="50"
          size="medium"
        ></el-input>
      </el-form-item>

      <div class="row">
        <div class="col-sm-6">
          <el-form-item
            label="Fecha de nacimiento"
            prop="fnac"
            :rules="[
              {
                type: 'date',
                required: true,
                message: 'Ingrese fecha de nacimiento',
                trigger: 'change',
              },
            ]"
          >
            <el-date-picker
              v-model="formAbonado.fnac"
              type="date"
              placeholder="seleccione"
              default-value="2000-01-01"
              format="dd/MM/yyyy"
              size="medium"
            >
            </el-date-picker>
          </el-form-item>
        </div>
        <div class="col-sm-6">
          <el-form-item
            label="Sexo"
            prop="sex"
            :rules="[
              { required: true, message: 'Selecciona sexo', trigger: 'change' },
            ]"
          >
            <el-select v-model="formAbonado.sex" placeholder="Selecciona">
              <el-option
                v-for="item in listSex"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                size="medium"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-6">
          <el-form-item
            label="Celular"
            prop="phone1"
            :rules="[
              {
                required: true,
                message: 'Este campo es obligatorio',
                trigger: 'blur',
              },
            ]"
          >
            <el-input v-model="formAbonado.phone1" maxlength="9"></el-input>
          </el-form-item>
        </div>
        <div class="col-sm-6">
          <el-form-item label="Teléfono fijo">
            <el-input v-model="formAbonado.phone2" maxlength="9"></el-input>
          </el-form-item>
        </div>
      </div>

      <div class="form-group row mb-0">
        <label class="col-sm-2 col-form-label text-left">Dirección*</label>
        <div class="col-sm-10">
          <el-form-item
            prop="address"
            :rules="[
              {
                required: true,
                message: 'Falta ingresar dirección',
                trigger: 'blur',
              },
            ]"
          >
            <el-input v-model="formAbonado.address" size="medium"></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="form-group row mb-0">
        <label class="col-sm-2 col-form-label text-left">Email*</label>
        <div class="col-sm-10">
          <el-form-item
            prop="email"
            :rules="[
              {
                required: true,
                message: 'Falta ingresar correo electrónico',
                trigger: ['blur', 'change'],
              },
              {
                type: 'email',
                message: 'Ingrese dirección de correo electrónico correcta',
                trigger: ['blur', 'change'],
              },
            ]"
          >
            <el-input
              v-model="formAbonado.email"
              size="medium"
              maxlength="100"
            ></el-input>
          </el-form-item>
        </div>
      </div>

      <div class="text-right">
        <button class="btn mb-3 mt-3 ml-2" @click.prevent="volver">
          Atras
        </button>
        <button
          class="btn outline-btn mb-3 mt-3 ml-2"
          @click.prevent="submitForm('formAbonado')"
        >
          Siguiente
        </button>
      </div>
    </el-form>

    <!--Modal Agregar vehiculo-->
    <el-dialog
      title="Agregar datos de vehículo"
      :visible.sync="dialog_add_vehiculo"
    >
    <el-form :model="formVehiculo" ref="formVehiculo" :label-position="'top'">
      <div class="row">
        <div class="col-sm-4">
          <el-form-item
            label="Tipo de vehículo"
            prop="idcategory"
            :rules="[
              {
                required: true,
                message: 'Este campo es obligatorio',
                trigger: 'change',
              },
            ]"
          >
            <el-select
              v-model="formVehiculo.idcategory"
              placeholder="Seleccione"
              size="medium"
              filterable
              class="w-100"
            >
              <el-option
                v-for="item in listTipoVehiculo"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>

        <div class="col-sm-4">
          <el-form-item
            label="Marca"
            prop="marca"
            :rules="[
              {
                required: true,
                message: 'Este campo es obligatorio',
                trigger: 'change',
              },
            ]"
          >
            <el-input v-model="formVehiculo.marca" size="medium"></el-input>
          </el-form-item>
        </div>
        <div class="col-sm-4">
          <el-form-item
            label="Modelo"
            prop="modelo"
            :rules="[
              {
                required: true,
                message: 'Este campo es obligatorio',
                trigger: 'change',
              },
            ]"
          >
            <el-input v-model="formVehiculo.modelo" size="medium"></el-input>
          </el-form-item>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-4">
          <el-form-item
            label="Placa"
            prop="placa"
            :rules="[
              {
                required: true,
                message: 'Este campo es obligatorio',
                trigger: 'change',
              },
            ]"
          >
            <el-input v-model="formVehiculo.placa" size="medium"></el-input>
          </el-form-item>
        </div>

        <div class="col-sm-4">
          <el-form-item
            label="Color"
            prop="color"
            :rules="[
              {
                required: true,
                message: 'Este campo es obligatorio',
                trigger: 'change',
              },
            ]"
          >
            <el-input v-model="formVehiculo.color" size="medium"></el-input>
          </el-form-item>
        </div>
        <div class="col-sm-4">
          <el-form-item
            label="N° Motor"
            prop="motor"
            :rules="[
              {
                required: true,
                message: 'Este campo es obligatorio',
                trigger: 'change',
              },
            ]"
          >
            <el-input v-model="formVehiculo.motor" size="medium"></el-input>
          </el-form-item>
        </div>
      </div>



      <div class="text-right">
        <button
          class="btn mb-3 mt-3 ml-2"
          @click.prevent="dialog_add_vehiculo = false"
        >
          cancelar
        </button>
        <button
          class="btn outline-btn mb-3 mt-3 ml-2"
          @click.prevent="addForm('formVehiculo')"
        >
          Agregar
        </button>
      </div>
 </el-form>

    </el-dialog>
  </div>
</template>

<script>
import dataJson from "@/data/common";
export default {
  props: {
    producto: {
      type: Object,
      required: true,
      default: {},
    },
  },
  data: () => ({
    documents_identity: dataJson.documents_identity,
    listSex: dataJson.sexo,
    maxlength: 8,
    listTipoVehiculo: [],
    formAbonado: {
      tdocument: "01",
    },
    formVehiculo: {
      idcategory: null,
      marca: null,
      modelo: null,
      placa: null,
      color: null,
      motor: null
    },
    dialog_add_vehiculo: false,
    listVehiculos: []
  }),
  methods: {
    async tipoVehiculo() {
      //alert(this.producto.idcategory)
      await axios
        .post(`${process.env.API2}/v1/abs/listarVehiculoAbonado`, {
          catalogoVehiculoId: this.producto.idcategory,
        })
        .then((res) => {
          this.listTipoVehiculo = res.data;
        });
    },
    volver() {
      this.$emit("resVolver", 1);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return false;

        //alert('Todo bien')
        this.$emit("resAbonado", this.formAbonado);
      });
    },

    addForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return false;

        if(this.listVehiculos.length > 1)
          return this.$message.error('Lo sentimos, solo está permitido el registro de 2 vehículos.');

        var vehiculo = {
          idcategory: this.formVehiculo.idcategory,
          marca: this.formVehiculo.marca,
          modelo: this.formVehiculo.modelo,
          placa: this.formVehiculo.placa,
          color: this.formVehiculo.color,
          motor: this.formVehiculo.motor
        }
        this.listVehiculos.push(vehiculo)

        //limpiar formulario
        /*this.formVehiculo.idcategory = null
        this.formVehiculo.marca = null
        this.formVehiculo.modelo = null
        this.formVehiculo.placa = null
        this.formVehiculo.color = null
        this.formVehiculo.motor = null*/

        this.dialog_add_vehiculo = false

        this.$refs[formName].resetFields();

      })

    },

    resetForm(formName) {
      //this.$refs[formName].resetFields();
    }
  },
  created() {
    this.tipoVehiculo();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/abonados/Abonado.vue